require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 677
// module chunks = 1